module.exports = __webpack_public_path__ + "static/media/carousel_bg.2463e56e.png";